import React, { useState } from "react";
import { Frequency } from "../../Utils/constants";
import "./ScheduleJobConfirmation.css";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
const ScheduleJobConfirmation = ({ isVisible, onClose, onConfirm }) => {
  const [selectedFrequency, setSelectedFrequency] = useState(Frequency.WEEKLY);

  if (!isVisible) return null;

  const handleConfirm = () => {
    onConfirm(selectedFrequency);
  };

  return (
    <div className="scheduler-overlay" onClick={onClose}>
      <div
        className="schedule-confirmation-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-header">
          <h3>Automate Your Search</h3>
        </div>
        <div>
          <p>
            Automatically run searches at a specified frequency without manual
            effort.
          </p>
          <FormControl variant="outlined" sx={{ minWidth: 120 }}>
            <InputLabel id="frequency-label">Frequency</InputLabel>
            <Select
              labelId="frequency-label"
              id="frequency"
              value={selectedFrequency}
              label="Frequency"
              onChange={(e) => setSelectedFrequency(e.target.value)}
            >
              {Object.values(Frequency).map((freq) => (
                <MenuItem key={freq} value={freq}>
                  {freq}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="card-actions">
          <button onClick={handleConfirm}>Yes, Schedule it!</button>
          <button onClick={onClose}>Maybe Later</button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleJobConfirmation;
